import './polyfills';

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import CacheBuster from 'react-cache-buster';
import pkg from '../package.json';

// redux dependencies
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import reducers from "./reducers";

// PWA
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import Loader from './components/reusables/Loader';

const store = createStore(reducers, compose(applyMiddleware(thunk)));

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <CacheBuster
      currentVersion={pkg.version}
      isEnabled={true}
      isVerboseMode={true}
      loadingComponent={<Loader />}
    >
      <Provider store={store}>
        <App />
      </Provider>
    </CacheBuster>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
